export default __webpack_public_path__ + "static/media/mob_preland_3.46cbfa1e.jpg";